<template>
  <span :class="[$style.chip]">
    {{ text }}
    <slot />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DolphinChip',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" module>
.chip {
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  padding: 0.1em 1.2em 0.3em;
  border-radius: 999em;
  font-size: 12px;
}
</style>
